import { store } from '@/store'

//  Listen for a network 'offline' event
window.addEventListener("offline", (event) => {
    store.getters.appDebug && console.log('NETWORK OFFLINE', event)
    store.commit('isOfflineSet', true)
});

//  Listen for network 'online' event
window.addEventListener("online", (event) => {
    store.getters.appDebug && console.log('NETWORK ONLINE', event)
    store.commit('isOfflineSet', false)
});